import React from 'react';
import PropTypes from 'prop-types';

const DynamicPriceDisplay = ({ enabled, currentPrice, basePrice, formatter, fallback }) => {
  if (!enabled || !currentPrice) return fallback;

  return (
    <div>
      <div>{formatter.format(currentPrice)}</div>
      <div className="text-muted" style={{ fontSize: '12px' }}>
        Base: {formatter.format(basePrice)}
      </div>
    </div>
  );
};

DynamicPriceDisplay.propTypes = {
  enabled: PropTypes.bool,
  currentPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  basePrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  formatter: PropTypes.shape({ format: PropTypes.func.isRequired }).isRequired,
  fallback: PropTypes.node
};

export default DynamicPriceDisplay;
